/**
 * The "Show map" checkbox. A page that never set show_map keeps the site's old
 * rule -- only the imported "Top Restaurants" page type gets a map -- so the
 * box shows what the site does today, and saving only writes the flag once an
 * editor has changed it.
 */
export const MAP_PAGE_TYPES = ['top restaurants'];

export function showsMap(page) {
  if (typeof (page || {}).show_map === 'boolean') return page.show_map;
  return MAP_PAGE_TYPES.includes(String((page || {}).source_page_type || '').trim().toLowerCase());
}

/** What a list item's geo says, for the line under its coordinates. */
export function geoStatus(geo) {
  if (!geo || typeof geo !== 'object') return 'No coordinates yet: the address line is looked up when you save.';
  const has = geo.lat !== null && geo.lat !== undefined && geo.lat !== '' && geo.lng !== null && geo.lng !== undefined && geo.lng !== '';
  const where = geo.address ? ` for “${geo.address}”` : '';
  if (geo.source === 'manual') return `Set by hand${where}. Kept until the address line changes.`;
  if (!has) return `No match found${where}. Enter coordinates by hand to place the pin.`;
  return `Looked up${where}.`;
}
